import { render, staticRenderFns } from "./halloween-rank.vue?vue&type=template&id=463b336c&scoped=true&"
import script from "./halloween-rank.vue?vue&type=script&lang=js&"
export * from "./halloween-rank.vue?vue&type=script&lang=js&"
import style0 from "./halloween-rank.vue?vue&type=style&index=0&id=463b336c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b336c",
  null
  
)

export default component.exports